import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export interface serverDate {
    serverDate: string
}

const initialState: serverDate = {
    serverDate: "",
}

export const serverDateSlice = createSlice({
    name: 'serverDate',
    initialState,
    reducers: {
        setServerDate: (state, action: PayloadAction<string>) => {
            state.serverDate = action.payload
        },
    },
})

// Action creators are generated for each case reducer function
export const { setServerDate } = serverDateSlice.actions

export default serverDateSlice.reducer